module.exports = __webpack_public_path__ + "static/img/pars4.5374ba17.png";